import {
  ADVANCED_SEARCH,
  ADVANCED_SEARCH_SUCCESS,
  ADVANCED_SEARCH_FAILURE,
  ADVANCED_SEARCH_RESET,
} from "./actionType";

const initialState = {
  loading: false,
  results: [],
  total: 0,
  page: 1,
  pageSize: 25,
  error: null,
};

const AdvancedSearch = (state = initialState, action) => {
  switch (action.type) {
    case ADVANCED_SEARCH:
      return { ...state, loading: true, error: null };
    case ADVANCED_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload?.search_list || [],
        total: action.payload?.total_count || 0,
        page: action.payload?.page || 1,
        pageSize: action.payload?.page_size || state.pageSize,
      };
    case ADVANCED_SEARCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ADVANCED_SEARCH_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default AdvancedSearch;
